import React, { memo } from "react";
import { useTranslation } from "react-i18next";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  UncoloredButtonText,
} from "../";

function ViewListDialog({ onClose, open, resource, children, ...rest }) {
  const { t } = useTranslation();

  return (
    <Dialog {...rest} open={open} onClose={onClose} fullScreen>
      <DialogTitle>{t("View {{resource}}", { resource })}</DialogTitle>
      <DialogContent>
        <DialogContentText>{children}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <UncoloredButtonText
          onClick={onClose}
          data-test-id="view-list-dialog-close-button"
        >
          {t("close")}
        </UncoloredButtonText>
      </DialogActions>
    </Dialog>
  );
}

export default memo(ViewListDialog);
